"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_81_51_1 = void 0;
/**
 * migrate invalid zugentlastungs items (breite associated by the art-nr)
 */
const migration_81_51_1 = (json) => {
    var _a;
    (_a = json.Zugentlastungen) === null || _a === void 0 ? void 0 : _a.forEach((zugentlastungJson) => {
        var _a, _b, _c, _d;
        // its a "normal" zugentlastung? ignore it..
        if (!((_b = (_a = zugentlastungJson.ArtNr) === null || _a === void 0 ? void 0 : _a['DE']) === null || _b === void 0 ? void 0 : _b.endsWith('XXX')))
            return;
        // we have a valid breite? ignore it..
        if (((_d = (_c = zugentlastungJson.Breite) === null || _c === void 0 ? void 0 : _c.Value) !== null && _d !== void 0 ? _d : 0) > 0)
            return;
        const artNrGenerated = zugentlastungJson.ArtNrGenerated;
        // no artNrGenerated? we cant migrate something here..
        if (!artNrGenerated)
            return;
        const artNrSplitter = (artNrGenerated === null || artNrGenerated === void 0 ? void 0 : artNrGenerated.includes('.')) ? '.' : '-';
        // splitter is not part of the artNrGenerated? ignore it..
        if (!artNrGenerated.includes(artNrSplitter))
            return;
        const desiredBreiteString = artNrGenerated.split(artNrSplitter).at(-1);
        // invalid breite? we cant migrate..
        if (!desiredBreiteString)
            return;
        const desiredBreite = Number.parseInt(desiredBreiteString, 10);
        if (isNaN(desiredBreite))
            return;
        zugentlastungJson.Breite = {
            Unit: 'mm',
            Value: desiredBreite,
        };
    });
    return json;
};
exports.migration_81_51_1 = migration_81_51_1;
//# sourceMappingURL=migration_81_51_1.js.map